const CourseraPlusHeroModuleColors = {
  black: 'black',
  white: 'white',
  lightBlue: 'light-blue',
  mistyBlue: 'misty-blue',
  blue: 'blue',
  darkBlue: 'dark-blue',
  lightPurple: 'light-purple',
  purple: 'purple',
  darkPurple: 'dark-purple',
  lightPink: 'light-pink',
  pink: 'pink',
  darkPink: 'dark-pink',
  lightYellow: 'light-yellow',
  yellow: 'yellow',
  darkYellow: 'dark-yellow',
  lightGreen: 'light-green',
  green: 'green',
  darkGreen: 'dark-green',
  darkRed: 'dark-red',
  red: 'red',
  lightRed: 'light-red',
  lightGrey: 'light-grey',
  grey: 'grey',
  darkGrey: 'dark-grey',
};

const COLOR_MAP = {
  [CourseraPlusHeroModuleColors.black]: 'var(--cds-color-neutral-primary)',
  [CourseraPlusHeroModuleColors.white]: 'var(--cds-color-neutral-background-primary)',
  [CourseraPlusHeroModuleColors.lightBlue]: 'var(--cds-color-emphasis-primary-background-xweak)',
  [CourseraPlusHeroModuleColors.mistyBlue]: 'var(--cds-color-emphasis-primary-background-weak)',
  [CourseraPlusHeroModuleColors.blue]: 'var(--cds-color-emphasis-primary-background-strong)',
  [CourseraPlusHeroModuleColors.darkBlue]: 'var(--cds-color-emphasis-primary-background-xxstrong)',
  [CourseraPlusHeroModuleColors.lightPink]: `var(--cds-color-emphasis-secondary-background-xweak)`,
  [CourseraPlusHeroModuleColors.pink]: `var(--cds-color-emphasis-secondary-background-default)`,
  [CourseraPlusHeroModuleColors.darkPink]: `var(--cds-color-emphasis-secondary-background-xstrong)`,
  [CourseraPlusHeroModuleColors.lightYellow]: `var(--cds-color-emphasis-tertiary-background-xweak)`,
  [CourseraPlusHeroModuleColors.yellow]: `var(--cds-color-emphasis-tertiary-background-default)`,
  [CourseraPlusHeroModuleColors.darkYellow]: `var(--cds-color-emphasis-tertiary-background-xstrong)`,
  [CourseraPlusHeroModuleColors.lightGreen]: `var(--cds-color-feedback-background-success-weak)`,
  [CourseraPlusHeroModuleColors.green]: `var(--cds-color-feedback-success)`,
  [CourseraPlusHeroModuleColors.darkGreen]: `var(--cds-color-feedback-success-hover)`,
  [CourseraPlusHeroModuleColors.lightRed]: `var(--cds-color-feedback-background-error-weak)`,
  [CourseraPlusHeroModuleColors.red]: `var(--cds-color-feedback-error)`,
  [CourseraPlusHeroModuleColors.darkRed]: `var(--cds-color-feedback-error-hover)`,
  [CourseraPlusHeroModuleColors.lightPurple]: `var(--cds-color-emphasis-quaternary-background-xweak)`,
  [CourseraPlusHeroModuleColors.purple]: `var(--cds-color-emphasis-quaternary-background-default)`,
  [CourseraPlusHeroModuleColors.darkPurple]: `var(--cds-color-emphasis-quaternary-background-xstrong)`,
  [CourseraPlusHeroModuleColors.lightGrey]: `var(--cds-color-emphasis-neutral-background-xweak)`,
  [CourseraPlusHeroModuleColors.grey]: `var(--cds-color-emphasis-neutral-background-default)`,
  [CourseraPlusHeroModuleColors.darkGrey]: `var(--cds-color-emphasis-neutral-background-xstrong)`,
};

const isInvertedColor = (color?: string | null) => {
  return [
    CourseraPlusHeroModuleColors.black,
    CourseraPlusHeroModuleColors.darkBlue,
    CourseraPlusHeroModuleColors.blue,
    CourseraPlusHeroModuleColors.darkPurple,
    CourseraPlusHeroModuleColors.purple,
    CourseraPlusHeroModuleColors.darkPink,
    CourseraPlusHeroModuleColors.pink,
    CourseraPlusHeroModuleColors.darkYellow,
    CourseraPlusHeroModuleColors.yellow,
    CourseraPlusHeroModuleColors.darkGreen,
    CourseraPlusHeroModuleColors.green,
    CourseraPlusHeroModuleColors.darkRed,
    CourseraPlusHeroModuleColors.red,
    CourseraPlusHeroModuleColors.grey,
    CourseraPlusHeroModuleColors.darkGrey,
  ].includes(color ?? '');
};

const getColorFromColorName = (color?: string | null) => {
  if (!color) {
    return COLOR_MAP[CourseraPlusHeroModuleColors.lightBlue];
  }

  return COLOR_MAP[color] ?? COLOR_MAP[CourseraPlusHeroModuleColors.lightBlue];
};

export { isInvertedColor, getColorFromColorName, CourseraPlusHeroModuleColors };
